// @todo module temporarily here
import { getHttp } from '@speechki-frontend/shared/axios/httpRef';

const state = {
    contractors: [],
    buildTypes: [],
    states: [],
    copyrightHolders: []
};

const getters = {};

const mutations = {
    SET_BUILD_TYPES(state, types) {
        state.buildTypes = types;
    },
    SET_CONTRACTORS(state, contractors) {
        state.contractors = contractors;
    },
    SET_STATES(state, states) {
        state.states = states;
    },
    SET_COPYRIGHT_HOLDERS(state, holders) {
        state.copyrightHolders = holders;
    }
};

const actions = {
    async fetchContractors({ commit }) {
        const { results } = await getHttp().get('/api/v1/contractors/');
        commit('SET_CONTRACTORS', results);
    },
    async fetchBuildTypes({ commit }) {
        const types = await getHttp().get('/api/v1/contractors_books/builds/');
        commit('SET_BUILD_TYPES', types);
    },
    async fetchStates({ commit }) {
        const states = await getHttp().get('/api/v1/contractors_books/states/');
        commit('SET_STATES', states);
    },
    async fetchCopyrightHolders({ commit }) {
        const { results } = await getHttp().get('/api/v1/admin/book/copyright_holders/');
        commit('SET_COPYRIGHT_HOLDERS', results);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
